import type {
  InitialIngredientQuantities,
  ModificationsMap,
  ProductIngredients,
} from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Generates a map of ingredient IDs to their initial quantities in the product recipe.
 */
export function generateInitialIngredientQuantities(
  ingredients: ProductIngredients,
  allModificationsMap: ModificationsMap,
): InitialIngredientQuantities {
  return ingredients.reduce<InitialIngredientQuantities>((map, ingredient) => {
    if (!allModificationsMap.has(ingredient.id)) return map;

    const currentQuantity = map.get(ingredient.id) ?? 0;

    map.set(ingredient.id, currentQuantity + 1);

    return map;
  }, new Map());
}
